export default {
	oemDataModal_remote_accountOwner: "Propietario de la cuenta",
	oemDataModal_remote_cancel: "Cancelar",
	oemDataModal_remote_checkFailed: "No se pudo consultar el estado. Inténtalo de nuevo.",
	oemDataModal_remote_checking: "Consultando el estado con el vehículo…",
	oemDataModal_remote_checkStatus: "Consultar estado",
	oemDataModal_remote_checkStatusIn: "Consultar estado ({seconds} s)",
	oemDataModal_remote_confirmLockBody: "¿Enviar el comando de bloquear puertas a {name}?",
	oemDataModal_remote_confirmLockTitle: "Bloquear puertas",
	oemDataModal_remote_confirmUnlockBody: "¿Enviar el comando de desbloquear puertas a {name}?",
	oemDataModal_remote_confirmUnlockTitle: "Desbloquear puertas",
	oemDataModal_remote_conflict: "Ya hay otro comando en curso para este vehículo. Espera a que termine e inténtalo de nuevo.",
	oemDataModal_remote_current: "Comando actual",
	oemDataModal_remote_empty: "Aún no se han enviado comandos a este vehículo",
	oemDataModal_remote_error: "No se pudieron cargar los comandos.",
	oemDataModal_remote_failed: "No se pudo enviar el comando al vehículo.",
	oemDataModal_remote_failedToast: "{command}: {status}.",
	oemDataModal_remote_historyTab: "Historial de comandos",
	oemDataModal_remote_loading: "Cargando comandos…",
	oemDataModal_remote_loadingMore: "Cargando más comandos…",
	oemDataModal_remote_loadMore: "Cargar más",
	oemDataModal_remote_lock: "Bloquear puertas",
	oemDataModal_remote_notAllowed: "No tienes permiso para enviar comandos a este vehículo.",
	oemDataModal_remote_requestedBy: "Por {name} · {when}",
	oemDataModal_remote_send: "Enviar",
	oemDataModal_remote_status_FAILED: "Falló",
	oemDataModal_remote_status_IN_PROGRESS: "En curso",
	oemDataModal_remote_status_REJECTED: "Rechazado",
	oemDataModal_remote_status_SUBMITTED: "En curso",
	oemDataModal_remote_status_SUCCEEDED: "Completado",
	oemDataModal_remote_status_TIMED_OUT: "Tiempo agotado",
	oemDataModal_remote_stillInProgress: "El vehículo aún no confirma el comando. Puedes volver a consultar su estado.",
	oemDataModal_remote_succeededToast: "{command}: completado.",
	oemDataModal_remote_tab: "Comandos remotos",
	oemDataModal_remote_unlock: "Desbloquear puertas",
	oemDataModal_remote_unlockWarning: "El vehículo quedará accesible para cualquier persona cercana.",
};
